import { Color, Select, SelectProps } from 'zens-storybook'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import tinycolor from 'tinycolor2'
import { useStore } from 'zens-store'

const styles = StyleSheet.create({
  content: {
    backgroundColor: tinycolor(Color.metalGrey).setAlpha(0.5).toRgbString(),
    borderWidth: 0,
  },
})

interface Props extends SelectProps<string> {}
const AuthLanguage = (props: Props) => {
  const { i18n } = useStore()
  const { t } = useTranslation()

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language, true)
  }

  const titleForLanguage = (language: string) => {
    switch (language) {
      case 'en':
        return t('English')
      case 'nl':
        return t('Dutch')
      default:
        return language
    }
  }
  return (
    <Select
      value={i18n.language}
      items={i18n.availableLanguages?.map((language) => ({
        value: language,
        title: titleForLanguage(language),
      }))}
      contentContainerStyle={styles.content}
      valueStyle={styles.content}
      placeholderTextColor={Color.metalGrey}
      round
      onSelect={changeLanguage}
      filterSelected
      {...props}
    />
  )
}

export default observer(AuthLanguage)
